import request from '@/utils/request'

export function getKhxxList(data) {
  return request({
    url: '/api/Extend/LqKhxx',
    method: 'get',
    data
  })
}

export function getKhxxInfo(id) {
  return request({
    url: `/api/Extend/LqKhxx/${id}`,
    method: 'get'
  })
}

/** 客户类型枚举（线索/新客/散客/会员等） */
export function getCustomerTypes() {
  return request({
    url: '/api/Extend/lqkhxx/deduct-types',
    method: 'get'
  })
}

/** 更新客户资料 */
export function updateKhxx(id, data) {
  return request({
    url: `/api/Extend/LqKhxx/${id}`,
    method: 'put',
    data
  })
}

export function getMemberRemainingItems(memberId) {
  return request({
    url: '/api/Extend/LqKhxx/GetMemberRemainingItems',
    method: 'get',
    data: { memberId }
  })
}

/** 是否首开订单 */
export function getMemberOrderType(memberId) {
  return request({
    url: `/api/Extend/lqkhxx/order-type/${memberId}`,
    method: 'get'
  })
}

/** 获取即将过生日的会员列表 */
export function getUpcomingBirthdays(data) {
  return request({
    url: '/api/Extend/LqKhxx/GetUpcomingBirthdays',
    method: 'get',
    data
  })
}

/** 健康师金三角（按月） */
export function getJsjInfo(userId, dateYmd) {
  return request({
    url: '/api/Extend/lqycsdjsj/GetJsjInfoByUserMonth',
    method: 'get',
    data: {
      UserId: userId,
      DateTime: dateYmd
    }
  })
}
